'use client';

import { VARIANT } from '@/constants';
import { FormCheckbox as CommonFormCheckbox } from '@monorepo/common';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

type FormCheckboxProps<T extends FieldValues> = UseControllerProps<T> & {
  label?: string;
  items: { value: string; child: React.ReactNode }[];
  required?: boolean;
  onChange?: () => void;
  hint?: string;
};

function FormCheckbox<T extends FieldValues>(props: FormCheckboxProps<T>) {
  return <CommonFormCheckbox {...props} variant={VARIANT} />;
}

export default FormCheckbox;
